// https://polygonscan.com/address/0xF6B99959F0b5e79E1CC7062E12aF632CEb18eF0d
export const CROSS_CHAIN_CONTROLLER = '0xF6B99959F0b5e79E1CC7062E12aF632CEb18eF0d';

// https://polygonscan.com/address/0xDAFA1989A504c48Ee20a582f2891eeB25E2fA23F
export const CL_EMERGENCY_ORACLE = '0xDAFA1989A504c48Ee20a582f2891eeB25E2fA23F';

// https://polygonscan.com/address/0x44c8b753229006A8047A05b90379A7e92185E97C
export const VOTING_MACHINE = '0x44c8b753229006A8047A05b90379A7e92185E97C';

// IPayloadsControllerCore https://polygonscan.com/address/0x401B5D0294E23637c18fcc38b1Bca814CDa2637C
export const PAYLOADS_CONTROLLER = '0x401B5D0294E23637c18fcc38b1Bca814CDa2637C';

// https://polygonscan.com/address/0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A
export const PC_DATA_HELPER = '0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A';

// https://polygonscan.com/address/0x77976B51569896523EE215962Ee91ff236Fa50E8
export const VM_DATA_HELPER = '0x77976B51569896523EE215962Ee91ff236Fa50E8';

// https://polygonscan.com/address/0x0D2CccD3dD420dC6DE2f24DB44aA22fADE290a02
export const GRANULAR_GUARDIAN = '0x0D2CccD3dD420dC6DE2f24DB44aA22fADE290a02';

// https://polygonscan.com/address/0x1A0581dd5C7C3DA4Ba1CDa7e0BcA7286afc4973b
export const GOVERNANCE_GUARDIAN = '0x1A0581dd5C7C3DA4Ba1CDa7e0BcA7286afc4973b';

// https://polygonscan.com/address/0xDf7d0e6454DB638881302729F5ba99936EaAB233
export const EXECUTOR_LVL_1 = '0xDf7d0e6454DB638881302729F5ba99936EaAB233';

// IVotingStrategy https://polygonscan.com/address/0xd755F1CA351E989391a5bacDeC8F780dFD76f5d2
export const VOTING_STRATEGY = '0xd755F1CA351E989391a5bacDeC8F780dFD76f5d2';

// IDataWarehouse https://polygonscan.com/address/0xE3D355a9E58D59Ad11F318deAED528f79A9C1e5a
export const DATA_WAREHOUSE = '0xE3D355a9E58D59Ad11F318deAED528f79A9C1e5a';

export const CHAIN_ID = 137;
